module.exports = __webpack_public_path__ + "static/netapp-7ad665fd3a771c5833e23c26fdb985ef.png";